export default {
  state:{
    UnreadNotificationsCount: 0,
    orgId: ''
  },
  mutations:{
    updateUnreadNotificationsCount(state, count){
      state.UnreadNotificationsCount = count;
    },
    updateEmployeeOrgId(state, orgId){
      state.orgId = orgId;
    }
  },
  getters:{
    getUnreadNotificationsCount(state){
      return state.UnreadNotificationsCount;
    },
    getOrgId(state){
      return state.orgId;
    }
  },
  actions:{// https://vuex.vuejs.org/en/actions.html

    fetchUnreadNotificationsCount({commit ,getters}) {
      let tempOrgId = getters.getOrgId
      if(tempOrgId !=  '' || tempOrgId != null || tempOrgId != undefined )
      {
      ajax.get(`/Notifications/GetUnreadNotificationsCount?empOrgId=${tempOrgId}`, {} , ( res ) =>{

        commit('updateUnreadNotificationsCount',parseInt(res.data));

      });
     }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Notification/index.js